import { make } from 'vuex-pathify';
import { ComparisonOptionsService } from '@/modules/global-settings/delinquency/services/comparison-options.service';
import Logger from '@/lib/logger.js';

const service = new ComparisonOptionsService();

const state = {
  comparisonOptions: null,
};

const mutations = make.mutations(state);
const getters = { ...make.getters(state) };

const actions = {
  async createComparisonOption(_, payload) {
    try {
      const { data } = await service.create(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Comparison Option');
      throw error;
    }
  },

  async findComparisonOptions({ commit }) {
    try {
      const { data } = await service.find();
      commit('SET_COMPARISON_OPTIONS', data);
      return data;
    } catch (error) {
      Logger.error('Finding Comparison Options');
      throw error;
    }
  },

  async updateComparisonOption(_, { id, payload }) {
    try {
      const { data } = await service.update(id, payload);
      return data;
    } catch (error) {
      Logger.error('Updating Comparison Option');
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
